const LanguageSelector = ({
    isOpen,
    setIsOpen,
    languages,
    changeLanguage,
    selected
}) => {
    return (
        <div className="relative flex flex-col items-start mt-4 md:mt-0 p-5 md:p-0 lg:p-0">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 text-sm font-medium border border-gray-300 px-3 py-2 rounded-md hover:bg-gray-100 focus:outline-none bg-white"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    <path d="M2 12h20"></path>
                </svg>
                <span>{selected}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="m6 9 6 6 6-6"></path>
                </svg>
            </button>

            {isOpen && (
                <div className="absolute left-0 top-10 mt-2 w-32 bg-white border border-gray-200 rounded shadow-md flex flex-col z-50">
                    {languages.map((lang) => (
                        <button
                            key={lang}
                            onClick={() => changeLanguage(lang)}
                            className="px-3 py-2 text-sm hover:bg-gray-100 text-left w-full"
                        >
                            {lang}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

export default LanguageSelector;